import Vue from 'vue'
import Router from 'vue-router'
import store from './store';

import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import Profile from './views/Profile.vue'
import Users from './views/Users.vue'
import Categories from './views/Categories.vue'
import Aspects from './views/Aspects.vue'
import Facilities from './views/Facilities.vue'
import Employees from './views/Employees.vue'
import Rating from './views/Rating.vue'
import Report from './views/Report.vue'
import ReportDetail from './views/ReportDetail.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/report',
      name: 'report',
      component: Rating,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/rating',
    //   name: 'rating',
    //   component: Rating,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/report/detail/:code',
    //   name: 'reportdetail',
    //   component: ReportDetail,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/rating/:code',
    //   name: 'ratingcode',
    //   component: Ratings,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/employees',
    //   name: 'employees',
    //   component: Employees,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/categories',
      name: 'categories',
      component: Categories,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/aspects',
      name: 'aspects',
      component: Aspects,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/facilities',
    //   name: 'facilities',
    //   component: Facilities,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '*',
      redirect: '/404',
      meta: {
        requiresAuth: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('fetchAccessToken');
  var requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  // console.log(requiresAuth)
  if(requiresAuth && !store.state.accessToken){
    next('/login')
  }
  if(!requiresAuth && store.state.accessToken){
    next('/')
  }
  next();
});

export default router